export default __webpack_public_path__ + "static/media/tulsi.118604ed.svg";